/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/jsx-filename-extension */
import { FileOutlined } from '@ant-design/icons';
import * as TramitesVehiculares from 'views/Tramites/TramitesVehiculares';
import * as ReportesDeTramites from 'views/Tramites/ReportesDeTramites';
import * as GPM from 'views/Tramites/GPM';
import * as SeguimientoDeTramites from 'views/Tramites/SeguimientoDeTramites';
import * as SeguimientoDeTramitesRepuve from 'views/Tramites/SeguimientoDeTramitesRepuve';

const ENV_NAME = process.env.REACT_APP_ENV_NAME;

export default {
  title: 'Trámites',
  icon: () => <FileOutlined />,
  children: [
    process.env.REACT_APP_ENV_NAME === 'nayarit' && {
      title: 'Trámites Vehículares',
      withoutLayout: true,
      component: TramitesVehiculares.default,
      permissionConfig: TramitesVehiculares.permissionConfig,
    },
    {
      title: 'Registrar trámite',
      component: GPM.default,
      permissionConfig: GPM.permissionConfig,
      withoutLayout: true,
    },
    {
      title: 'Seguimiento de Trámites',
      component: SeguimientoDeTramites.default,
      permissionConfig: SeguimientoDeTramites.permissionConfig,
    },
    ENV_NAME === 'repuve' && {
      title: 'Seguimiento de Trámites finalizados',
      component: SeguimientoDeTramitesRepuve.default,
      permissionConfig: SeguimientoDeTramitesRepuve.permissionConfig,
    },
    {
      title: 'Trámites Vehículares V2',
      showInSidebar: false,
      component: TramitesVehiculares.default,
      permissionConfig: TramitesVehiculares.permissionConfig,
      withoutLayout: true,
      componentProps: { useAutoAssing: true },
    },
    {
      title: 'Reportes de Trámites',
      component: ReportesDeTramites.default,
      permissionConfig: ReportesDeTramites.permissionConfig,
    },
  ],
};
